import { NamespacedIntl } from '@spa/lib/i18n/common/NamespacedIntl';
import { PageTemplate } from '@spa/lib/cms/const';
import { SessionsData } from '@spa/lib/auth/sessionTypes';
import { UsePopularityEventsAPIResult } from '@spa/lib/react/hooks/usePopularityEventsAPI';
import { createContext } from 'react';
import { useContext } from 'react';
export interface ProductTileContextValue {
  readonly countryCode: string;
  readonly fullPath: string;
  readonly lastQueryMetadata: Record<string, string>;
  readonly locale: string;
  readonly namespacedIntl: NamespacedIntl;
  readonly pageTemplate: PageTemplate;
  readonly popularityEventsEnabled: boolean;
  readonly preOrderEnabled: boolean;
  readonly pricesIncludeTax: boolean;
  readonly sendClickEvent: UsePopularityEventsAPIResult['sendClickEvent'];
  readonly sessionsData: SessionsData;
  readonly pathname: string;
  readonly isWishlistEnabled: boolean;
}
export const ProductTileContext = createContext<ProductTileContextValue | null>(null);
export const useProductTileContext = () => {
  return useContext(ProductTileContext);
};